// extracted by mini-css-extract-plugin
module.exports = {"homeContent":"PageContentLayout_homeContent__3li1a","header":"PageContentLayout_header__3RNeP"};